import { createIcon } from '@chakra-ui/react'

const IconPencil = createIcon({
  displayName: 'IconPencil',
  viewBox: '0 0 24 24',
  path: (
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"
    />
  )
})

export default IconPencil
